/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/alt-text */
import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import projImg1 from "../assets/img/project-img1.png";
import projImg2 from "../assets/img/project-img2.jpg";
import projImg3 from "../assets/img/project-img3.png";
import projImg4 from "../assets/img/project-img4.png";
import colorSharp2 from "../assets/img/color-sharp2.png";
import 'animate.css';
import TrackVisibility from 'react-on-screen';

const tictactoelink ="http://myfirstprojecttictactoe.surge.sh";
const tigergymlink ="https://tigerfitnessclub.netlify.app/";
const advicelink="https://livequotes.netlify.app/";
const fightlink ="https://fightstarts.netlify.app/";
export const Projects = () => {

  const projects = [
    {
      title: "TicTacToe",
      description: "React js & JavaScript",
      imgUrl: projImg1,
      hreftag: tictactoelink,
    },
    {
      title: "Tiger fitness club",
      description: "React js  & Fetch api",
      imgUrl: projImg2,
      hreftag:tigergymlink,
    },
    {
      title: "Fighting Game",
      description: "JavaScript, Css & Canva",
      imgUrl: projImg3,
      hreftag:fightlink,
    },
    {
      title: " Take my Advice",
      description: "React js & axios",
      imgUrl: projImg4,
      hreftag: advicelink,
    
    },
    
  ];

  return (
    <section className="project" id="project">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) =>
              <div className={isVisible ? "animate__animated animate__fadeIn": ""}>
                <h2>Projects</h2>
                <p>The main objective of these personal projects are to showcase my ability and passion for work</p>
                <Tab.Container id="projects-tabs" defaultActiveKey="first">
                  <Nav variant="pills" className="nav-pills mb-5  justify-content-center align-items-center" id="pills-tab">
                    <Nav.Item>
                      <Nav.Link eventKey="first">Tab 1</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="second">Tab 2</Nav.Link>
                    </Nav.Item>
                  </Nav>
                  <Tab.Content id="slideInUp" className={isVisible ? "animate__animated animate__slideInUp" : ""}>
                    <Tab.Pane eventKey="first">
                      <Row>
                        {
                          projects.map((project, index) => {
                            return (
                              <ProjectCard
                                key={index}
                                {...project}
                                />
                            )
                          })
                        }
                      </Row>
                    </Tab.Pane>
                    <Tab.Pane eventKey="second">
                      <p>In these projects, I use html, css ,material ui and React.js for frontend development and for backend i use Express.js and in some of my project use rapid api service. For deployment i mainly use netlify service
                      </p>
                       </Tab.Pane>
                  </Tab.Content>
                </Tab.Container>
              </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      <img className="background-image-right" src={colorSharp2}></img>
    </section>
  )
}
